import { OBV_COLOUR_MAX } from '@/consts/visualisations';

export const normaliseObv = (obv: number) => {
  const clamped = Math.max(-OBV_COLOUR_MAX, Math.min(OBV_COLOUR_MAX, obv));
  return (clamped + OBV_COLOUR_MAX) / (2 * OBV_COLOUR_MAX);
};
